module.exports = __webpack_public_path__ + "static/media/ada.f7a798d1.png";